import Button from "../button/button.jsx";

export default function CellRendererButton({ title, onClick, target = "primary", icon: Icon }) {
    return (
        <div className="w-full h-full flex justify-center items-center">
            <Button
                title={title}
                onClick={onClick}
                target={target}
                className="h-[30px]! w-[30px]! p-[0]!"
            >
                <Icon />
            </Button>
        </div>
    )
}